import {
  REQUEST_FAQ_LIST,
  REQUEST_FAQ,
} from './mutation-types'

export default {
  [REQUEST_FAQ_LIST](state, receivedData) {
    state.faqList = receivedData.content
    state.faqListCount = receivedData.totalElements
  },
  [REQUEST_FAQ](state, receivedData) {
    state.faq = receivedData
  },
}